import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  childCard: {
    borderRadius: 0,
    marginBottom: 0,
    marginTop: 0,
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginBottom: 0,
      }),
    },
  },
  lastChildCard: {
    borderRadius: '0px 0px 20px 20px',
    marginBottom: theme.spacing(2),
  },
}));
